module.exports = __webpack_public_path__ + "assets/color-bounce-white.fbcb191768241e6fb7bbeb357ce4b7a8.gif";